export default {
    api:{
        endpoint: process.env.NODE_ENV === "development" ? "http://127.0.0.1:8080" : "https://www.haoping.fun/api"
    },
    isProd: process.env.NODE_ENV !== "development"
}
